import { BlocksBadge } from 'blocks-nextjs/blocks-web-components/components/badge/badge';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatBadge = createComponent({ react: React, tagName: 'cat-badge', elementClass: BlocksBadge });
